/* import __COLOCATED_TEMPLATE__ from './loading-link.hbs'; */
/* RESPONSIBLE TEAM: team-standalone */

import { type InterfaceIconName } from '@intercom/pulse/lib/interface-icons';
import templateOnlyComponent from '@ember/component/template-only';

export interface Signature {
  Args: {
    icon: InterfaceIconName;
    translationKey: string;
  };
}

const StandaloneNavLoadingLink = templateOnlyComponent<Signature>();
export default StandaloneNavLoadingLink;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Standalone::Navbar::LoadingLink': typeof StandaloneNavLoadingLink;
    'standalone/navbar/loading-link': typeof StandaloneNavLoadingLink;
  }
}
